import AudioManager from "../../Shared/AudioManager";
import Utils from "../../Shared/Utils";
import UIManager from "../../Shared/UIManager";
import { Global } from "../../Shared/Global";
import HallUI from "../HallUI";

const {ccclass, property} = cc._decorator;

@ccclass
export default class RechargeInfoUI extends cc.Component {
    @property(cc.Prefab)
    pfbCustomerServiceUI: cc.Prefab = null
    
    @property(cc.Label)
    lbMoney: cc.Label = null

    @property(cc.Label)
    lbOrder: cc.Label = null

    @property(cc.Label)
    lbDate: cc.Label = null

    @property(cc.Label)
    lbType: cc.Label = null

    @property(cc.Label)
    lbState: cc.Label = null

    @property(cc.Float)
    private _money: number = 0

    @property({type: cc.Flags})
    set money (value) {
        this._money = value
        this.lbMoney.string = "+" + this._money
    }

    get money () {
        return this._money
    }

    @property(cc.String)
    private _order: string = ""

    @property({type: cc.String})
    set order (value) {
        this._order = value
        this.lbOrder.string = "订单号：" + this._order
    }

    get order () {
        return this._order
    }

    @property(cc.String)
    private _date: string = ""

    @property({type: cc.String})
    set date (value) {
        this._date = value
        this.lbDate.string = "充值时间：" + this._date
    }

    get date () {
        return this._date
    }

    @property(cc.String)
    private _type: string = ""

    @property({type: cc.String})
    set type (value) {
        this._type = value
        this.lbType.string = "充值方式：" + (this._type || "转账")
    }

    get type () {
        return this._type
    }

    @property(cc.Integer)
    private _state: number = 0

    @property({type: cc.Integer})
    set state (value) {
        let states = ["成功", "失败", "审核中", "充值失败"]
        let colors = [cc.color(74, 190, 139), cc.color(190, 74, 74), cc.color(190, 190, 74), cc.color(190, 74, 74)]
        this._state = value
        this.lbState.string = states[this._state]
        this.lbState.node.color = colors[this._state]
    }

    get state () {
        return this._state
    }

    onBtnClick (event, userData) {
        if (userData === "close") {
            AudioManager.playSound("close")
            this.node.destroy()
        }else if (userData === "customer") {
            let hallUI = cc.find("Canvas/gameNode") && cc.find("Canvas/gameNode").getComponent(HallUI)
            hallUI && hallUI.openChildUI(this.pfbCustomerServiceUI)
            this.node.destroy()
        }else if (userData === "copy") {
            Utils.copyText(this._order)
            UIManager.showToastUI("复制成功", Global.ToastType.OK)
        }
    }
}
